import {
  Box,
  Checkbox,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";

interface Props {
  label?: string;
  name: string;
  size?: "small" | "medium";
  control: any;
  options: Array<{ label: string; value: string }>;
  style?: any;
  onChange?: (value: any) => void;
  required?: boolean;
  readOnly?: boolean;
  sx?: any;
  color?: string;
}

function FormMultiSelect(props: Props) {
  const {
    name,
    size = "small",
    options = [],
    control,
    label = "",
    style,
    onChange,
    required = false,
    readOnly = false,
    sx,
    color,
  } = props;

  const valueToLabelMap = options.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {} as Record<string, string>);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ ...sx }}>
          <InputLabel
            sx={{
              opacity: "100%",
              pb: "3px",
              fontSize: "14px",
            }}
            id="demo-simple-select-label"
          >
            {label}
          </InputLabel>
          <Select
            sx={{ borderRadius: "10px" }}
            labelId={`${name}-label`}
            multiple
            value={field.value || []}
            onChange={(e) => {
              const value = e.target.value as string[];
              if (onChange) onChange(value);
              field.onChange(value);
            }}
            inputProps={{ readOnly: readOnly }}
            variant="outlined"
            fullWidth
            size={size}
            style={style}
            error={Boolean(error)}
            renderValue={(selected) => {
              return (selected as string[])
                .map((value) => valueToLabelMap[value])
                .join(", ");
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                },
              },
            }}
          >
            {options?.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                <Checkbox checked={field.value?.indexOf(item.value) > -1} />
                <ListItemText primary={item.label} />
              </MenuItem>
            ))}
          </Select>
          {error && (
            <Typography
              variant="caption"
              sx={{ pl: "2px", display: "block" }}
              color="rgb(211, 47, 47)"
            >
              {error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
}

export default FormMultiSelect;
